"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SectionHeader = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    return ((0, jsx_runtime_1.jsx)("h3", { className: "text-base font-semibold text-primary border-b border-border pb-1.5 ".concat(className), children: children }));
};
exports.SectionHeader = SectionHeader;
